import { render, staticRenderFns } from "./billingComissionComponent.vue?vue&type=template&id=09746661&scoped=true"
import script from "./billingComissionComponent.vue?vue&type=script&lang=js"
export * from "./billingComissionComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09746661",
  null
  
)

export default component.exports